// ConsultJSON của api_gateway là structpb.AsMap() của đúng body REST fulfillment_be, nên DTO giữ nguyên
// (kể cả false/0/null và thứ tự mảng). Converter chỉ bóc root consultRequestAdmin và giữ shape REST mà UI dùng.

const root = (data) => data?.consultRequestAdmin || {};
const field = (data, name) => root(data)[name] ?? null;
const asList = (value) => (Array.isArray(value) ? value : []);

// PW1: { total, items: [...] }
export const convertConsultRequestList = (data) => field(data, "consultRequests");
// PW2: { ALL, NEW, ... }
export const convertStatusCounts = (data) => field(data, "statusCounts");
export const convertProjectTypeOptions = (data) => asList(field(data, "projectTypeOptions"));
export const convertConsultRequestDetail = (data) => field(data, "consultRequest");
export const convertAssignees = (data) => asList(field(data, "assignees"));
export const convertNotes = (data) => field(data, "notes");
export const convertFiles = (data) => field(data, "files");
export const convertHistories = (data) => field(data, "histories");

// Mutation trả JSON REST tương ứng (chi tiết phiếu / ghi chú / file vừa tải).
export const convertMutationResult = (name) => (data) => field(data, name);
export const convertDeleteFile = (data) => field(data, "deleteFile") === true;

const base64ToBytes = (content) => {
  const binary = atob(content || "");
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) bytes[i] = binary.charCodeAt(i);
  return bytes;
};

// downloadFile trả nội dung base64 thay cho URL tải REST.
export const convertDownloadFile = (data) => {
  const file = field(data, "downloadFile");
  if (!file) return null;
  return {
    id: file.id,
    fileName: file.fileName,
    contentType: file.contentType,
    blob: new Blob([base64ToBytes(file.content)], { type: file.contentType || "application/octet-stream" }),
  };
};
